// mds-dojo — dojox/widget/Calendar — FAITHFUL port of references/dojox/widget/Calendar.js.
//
// The standard Calendar: the _CalendarBase composed with the day and month/year view
// mixins. No visual effects. This is a genuinely thin wrapper in the real source too;
// the weight lives in _CalendarBase + the view chain, which is stubbed here (see
// _CalendarBase.ts for the TODO on porting the full closure). Not referenced by the
// oracle app/suite.
//
// PORT NOTES: AMD define(...) → ESM imports; classic declare() kept via the faithful
// declare-runtime. dojo/_base/kernel dropped (only used for kernel.experimental()).

import declare from '../../dojo/_base/declare-runtime';
import _CalendarBase from './_CalendarBase';
import _CalendarDay from './_CalendarDay';
import _CalendarMonthYear from './_CalendarMonthYear';

export default declare('dojox.widget.Calendar', [_CalendarBase, _CalendarDay, _CalendarMonthYear], {
  // summary:
  //		The standard Calendar. It includes day and month/year views. No visual
  //		effects are included.
});
